module.exports = "<div class=\"inflate\" (resize)=\"onResize($event)\">\n    <ng-content></ng-content>\n</div>\n"